class Toolbarmobile extends HTMLElement {
  constructor() {
    super();

    if (theme.config.mqlSmall || theme.config.isTouch) this.init();
  }

  init() {
    this.activate();
    this.setHeight();
    window.addEventListener('resize', theme.utils.rafThrottle(this.setHeight.bind(this)));
    window.addEventListener('scroll', theme.utils.rafThrottle(this.handleScroll.bind(this)));
    this.handleScroll();
  }

  activate() {
    const header = document.querySelector(".header[data-sticky-state='inactive']");
    header === null
      ? this.classList.add("active")
      : this.classList.remove("active");
  }

  setHeight() {
    document.body.style.setProperty('--toolbar-mobile-height', `${this.clientHeight}px`);
  }
  handleScroll() {
    const scrollY = window.scrollY || document.documentElement.scrollTop || 0;
    if (scrollY > (this.lastScrollY || 0)) {
      this.classList.add('toolbar-mobile--hidden');
    } else {
      this.classList.remove('toolbar-mobile--hidden');
    }
    this.lastScrollY = scrollY;
  }
}
customElements.define("toolbar-mobile", Toolbarmobile);
